export const FETCH_SIGN_UP_CLIENT_REQUEST = 'FETCH_SIGN_UP_CLIENT_REQUEST'
export const FETCH_SIGN_UP_CLIENT_SUCCESS = 'FETCH_SIGN_UP_CLIENT_SUCCESS'
export const FETCH_SIGN_UP_CLIENT_FAILURE = 'FETCH_SIGN_UP_CLIENT_FAILURE'
export const SIGN_UP_CLIENT_RESET = 'SIGN_UP_CLIENT_RESET'
